module.exports = __webpack_public_path__ + "static/media/beautifulLives.7f7b94cd.png";